module.exports = __webpack_public_path__ + "be9b59db5858278c988ab8adde4a98fd.pdf";